import React from "react";

const tones = {
  neutral: { bg: "var(--crm-neutral-soft)", fg: "var(--crm-neutral)" },
  primary: { bg: "var(--crm-primary-soft)", fg: "var(--crm-primary)" },
  success: { bg: "var(--crm-success-soft)", fg: "var(--crm-success)" },
  warning: { bg: "var(--crm-warning-soft)", fg: "var(--crm-warning)" },
  danger:  { bg: "var(--crm-danger-soft)",  fg: "var(--crm-danger)" },
  info:    { bg: "var(--crm-info-soft)",    fg: "var(--crm-info)" },
};

export default function Badge({ tone = "neutral", children, dot = false }) {
  const t = tones[tone] || tones.neutral;
  return (
    <span style={{ background: t.bg, color: t.fg, display: "inline-flex", alignItems: "center", gap: 5, padding: "1px 7px", borderRadius: 4, fontSize: 11, fontWeight: 500, lineHeight: "18px", whiteSpace: "nowrap" }}>
      {dot && <span style={{ width: 6, height: 6, borderRadius: 9999, background: "currentColor" }} />}
      {children}
    </span>
  );
}
